import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/user";
import Button from "@/atomic/atoms/Button";

export default function RegisterView({
  goBack,
  user,
  onChange,
  goToPin,
  isDisabled,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Recibos"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="mt-6 text-black text-xl">Validar acesso</h2>
            <h3 className="text-black text-sm">Precisamos validar seus dados de acesso, informe abaixo o CPF usado para os pagamentos.</h3>
            <div className="flex flex-col justify-center items-center">
              <InputMask 
                value={user?.document as string}
                name="document"
                required 
                onChange={onChange} 
                type="text"
                mask="___.___.___-__"
                replacement={{ _: /\d/ }}
                placeholder="CPF"
                className="mt-5 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
            </div>
          </div>
          <Button 
            title="Avançar"
            onClick={goToPin}
            type="submit"
            isDisabled={isDisabled}
          />
        </article>
      </main>
    </div>
  );
}
